import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Services from '../elements/ServiceOne';
import WorkingProcess from '../elements/WorkingProcess';
import Counter from "../elements/Counter";
import Faq from "../elements/FaqThree";
import Footer from '../elements/Footer';



function Service() {
  return (

        <div className="service-page">
            <Header/>
            <main>
                <Breadcrumb title="Service" sub_title="Home" active="Service"/>
                <Services/>
                <WorkingProcess/>
                <Counter/>
                <Faq/>
                <Footer/>

            </main>
        </div>
    )
}

export default Service